import { useHistory } from "react-router-dom";

import * as utils from '../services/utils';

import './NavMain.css';

function NavMenu() {
  const history = useHistory();

  function handleTransactionType(transType) {
    switch (transType) {
      case utils.TRANS.auth_code:
        history.replace("/");
        break;
      case utils.TRANS.client_credentials:
        history.replace("/cc");
        break;
      case utils.TRANS.auth_metadata:
        history.replace("/md");
        break;
      default:
        //
    }
  }

  return (
    <header className='header main-nav'>
      <nav>
        <ul>
          <li>
            <button className='button-link' onClick={() => handleTransactionType(utils.TRANS.auth_code)}>Authorization Code Flow [ITI-71]</button>
          </li>
          <li>
            <button className='button-link' onClick={() => handleTransactionType(utils.TRANS.client_credentials)}>Client Credentials Flow [ITI-71]</button>
          </li>
          <li>
            <button className='button-link' onClick={() => handleTransactionType(utils.TRANS.auth_metadata)}>Authorization Server Metadata [ITI-103]</button>
          </li>
        </ul>
      </nav>
    </header>    
  );
}

export default NavMenu;